import { SVGProps } from "react";

export function ProductOrdersIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        d="M3.9998 20V7.1L2.0498 2.85L3.8498 2L6.1998 7.05H17.7998L20.1498 2L21.9498 2.85L19.9998 7.1V20H3.9998ZM9.9998 13H13.9998C14.2831 13 14.5208 12.904 14.7128 12.712C14.9048 12.52 15.0005 12.2827 14.9998 12C14.9991 11.7173 14.9031 11.48 14.7118 11.288C14.5205 11.096 14.2831 11 13.9998 11H9.9998C9.71647 11 9.47914 11.096 9.2878 11.288C9.09647 11.48 9.00047 11.7173 8.9998 12C8.99914 12.2827 9.09514 12.5203 9.2878 12.713C9.48047 12.9057 9.7178 13.0013 9.9998 13Z"
        fill={color}
      />
    </svg>
  );
}
